import { render, staticRenderFns } from "./ModalSelectRecipe.vue?vue&type=template&id=06b2bd42"
import script from "./ModalSelectRecipe.vue?vue&type=script&lang=js"
export * from "./ModalSelectRecipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports